import channels, { Channel } from '@root/modules/channel/config/channel.config';
import getAliasByLocale from '@root/common/utils/getAliasByLocale';

type BuildNavigationUrl = (url: string, fakeDomainEnabled?: boolean, locale?: string) => string;

function buildNavigationDevUrl(channelConfig: Channel, url?: string) {
  let pathName;

  if (url) {
    try {
      pathName = new URL(url).pathname;
    } catch (e) {
      console.log('Failed to parse url in buildNavigationDevUrl', e);
    }
  }

  // In case path is frontpage, pahtName is /
  // in case path is latest, pathName is /latest
  // So in case of frontpage function return will make double slash
  // TODO: Try to use URL class, to combine path properly
  if (pathName === '/') {
    pathName = '';
  }

  const origin = process.client ? document.location.origin : '';

  // URL pathname parameter already contains slash
  return `${origin}${pathName}/`;
}

// Build dev or live issue url
const buildNavigationUrl: BuildNavigationUrl = (url, fakeDomainEnabled, locale = 'lt_LT') => {
  let newUrl = url;

  if (!fakeDomainEnabled) {
    return newUrl;
  }
  // TODO: Change after Content-api channel object will return channel url
  const channelConfig =
    channels.find((ch) => {
      const urlHost = url.replace(/^https?:\/\//, '').split('/');
      const chUrlHost = ch.url.replace(/^https?:\/\//, '').split('/');

      return urlHost[0] === chUrlHost[0] && (urlHost[1] === chUrlHost[1] || (!chUrlHost[1] && urlHost[1] === getAliasByLocale(locale, 'page')));
    }) || null;

  if (channelConfig && !channelConfig.old_type_redirects_dev) {
    newUrl = buildNavigationDevUrl(channelConfig, url);
  }

  return newUrl;
};

export default buildNavigationUrl;
